// Complete, deterministic reads are required before recalculating standings.
export async function readAllMatches(client) {
  const rows = [];
  for (let offset = 0; ; offset += 1000) {
    const { data, error } = await client
      .from('matches')
      .select('*')
      .order('date', { ascending: false })
      .order('created_at', { ascending: false })
      .order('id', { ascending: false })
      .range(offset, offset + 999);
    if (error) throw error;
    rows.push(...(data || []));
    if (!data || data.length < 1000) return rows;
  }
}
export function matchSnapshot(matches) {
  return matches
    .map((match) =>
      Object.fromEntries([
        ...[
          'id',
          'date',
          'player1_id',
          'player2_id',
          'player3_id',
          'player4_id',
          'match_type',
          'match_category',
          'score_type',
          'sets',
          'winner_id',
        ].map((key) => [
          key,
          key === 'date' && match.date instanceof Date
            ? match.date.toISOString().slice(0, 10)
            : (match[key] ?? null),
        ]),
        [
          'created_ms',
          match.created_at ? new Date(match.created_at).getTime() : null,
        ],
      ]),
    )
    .sort((a, b) => a.id.localeCompare(b.id));
}
